import { ThemeEnum } from '../enum/Theme';

export function applyTheme(theme: ThemeEnum) {
  document.documentElement.setAttribute('data-theme', theme);
}
